<div class="container-fluid px-0 bg-star">
<div class="container py-5">
    <div class="row">
        <div class="col-md-8 col-lg-6 m-auto">
            <div class="signup-form">
                <h5 class="mb-4">Sign Up</h5>
                <form [formGroup]="gymOwnerForm" (ngSubmit)="onSigup(gymOwnerForm)">
                    <div class="form-group">
                        <label for="" class="form-label d-block">Sign up as:</label>
                        <div class="popover-wrap-2 ms-2">
                            <input type="radio" formControlName="form_type" [checked]="f['form_type'].value=='coach'" (click)="changeFormType('coach')" value="coach" name="form_type" id="coach">
                            <label for="coach" class="d-inline-block ms-2 form-label">
                                <span>Coach</span>
                            </label>
                            <div class="popover-content">A single account with access to our video library. Ideal for smaller gyms and individual coaches.</div>
                        </div>
                        <div class="popover-wrap-2 ms-2">
                            <input type="radio" formControlName="form_type" [checked]="f['form_type'].value=='gym_owner'" (click)="changeFormType('gym_owner')" value="gym_owner" name="form_type" id="gymowner">
                            <label for="gymowner" class="d-inline-block ms-2 form-label">
                                <span>Gym Owner</span>
                            </label>
                            <div class="popover-content">3 Coach accounts (2 to be assigned by the main account) that can share lists. Ideal of larger programs with Recreation or Competitive Directors.</div>
                        </div>
                    </div>
                    <div class="row">
                        
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="" class="form-label">First Name:</label>
                                <input type="text" class="form-control" formControlName="first_name">
                                <div class="invalid-feedback d-block"
                                    *ngIf="f['first_name'].errors?.['required'] && (f['first_name'].dirty || f['first_name'].touched)">
                                    Please fill first name.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="" class="form-label">Last Name:</label>
                                <input type="text" class="form-control" formControlName="last_name">
                                <div class="invalid-feedback d-block"
                                    *ngIf="f['last_name'].errors?.['required'] && (f['last_name'].dirty || f['last_name'].touched)">
                                    Please fill last name.
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                    <hr class="my-3"/>

                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="emailInput" class="form-label">Your Email address</label>
                                <input type="email" class="form-control" formControlName="email" id="emailInput">
                                <div class="invalid-feedback d-block"
                                    *ngIf="(f['email'].errors?.['required'] || f['email'].errors?.['email']) && (f['email'].dirty || f['email'].touched)">
                                    Please fill valid email.
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="emailInput" class="form-label">Re-Enter Your Email address</label>
                                <input type="email" class="form-control" formControlName="re_email" id="emailInput">
                                <div *ngIf="f['re_email'].touched && f['re_email'].invalid" class="invalid-feedback d-block">
                                    <div *ngIf="f['re_email'].errors['confirmedValidator']">Email and Re-Enter Email must be match.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="" class="form-label">Create Password:</label>
                                <input type="password" class="form-control" formControlName="password">
                                <div class="invalid-feedback d-block"
                                    *ngIf="(f['password'].errors?.['required'] || f['password'].errors?.['minlength']) && (f['password'].dirty || f['password'].touched)">
                                    Please fill 8 character long password.
                                </div>
                            </div>
                            
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label for="" class="form-label">Re-Enter Password:</label>
                                <input type="password" class="form-control" formControlName="re_password">
                                
                                <div *ngIf="f['re_password'].touched && f['re_password'].invalid" class="invalid-feedback d-block">
                                    <div *ngIf="f['re_password'].errors['confirmedValidator']">Password and Re-Enter Password must be match.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <hr class="my-3"/>
                    <!-- <div class="form-group">
                        <label for="" class="form-label">Number of Coaches in Gym:</label>
                        <input type="text" class="form-control" formControlName="number_of_coaches">
                        <div class="invalid-feedback d-block"
                            *ngIf="(f['number_of_coaches'].errors?.['required'] || f['number_of_coaches'].errors?.['pattern']) && (f['number_of_coaches'].dirty || f['number_of_coaches'].touched)">
                            Please fill number of coaches in gym.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Number of Athletes in Gym:</label>
                        <input type="text" class="form-control" formControlName="number_of_athletes">
                        <div class="invalid-feedback d-block"
                            *ngIf="(f['number_of_athletes'].errors?.['required'] || f['number_of_athletes'].errors?.['pattern']) && (f['number_of_athletes'].dirty || f['number_of_athletes'].touched)">
                            Please fill number of athletes in gym.
                        </div>
                    </div> -->
                    <!-- <div class="form-group">
                        <input type="checkbox" formControlName="trial" [checked]="f['trial'].value" value="1" name="trial" id="trial">
                        <label for="trial" class="d-inline-block ms-2 form-label">Activate Trial</label>
                    </div> -->
                    <div class="row" *ngIf="plans && f['trial'].value!=1">
                        <label for="" class="form-label">Purchase Plan</label>
                        <div class="col-md-6 mb-2">
                            <div class="plan-box">
                                <div class="heading mb-3">
                                    Level 1
                                </div>
                                <!-- <div class="sub-heading mb-3">
                                    [NOVICE - MEDIAN]
                                </div> -->
                                    <div class="input-radios-wrap">
                                        <div>
                                            <input type="radio" value="" (click)="selectFree()" [checked]="getValue('plan')" id="planfree">
                                            <label for="planfree">Free</label>
                                        </div>
                                    </div>
                                    <label>All the same features, but free!</label>
                            </div>
                        </div>
                        <div class="col-md-6 mb-2" *ngFor="let plan of plans">
                            <div class="plan-box">
                                <div class="heading mb-3">
                                    {{plan[0].title}}
                                </div>
                                <!-- <div class="sub-heading mb-3">
                                    [NOVICE - MEDIAN]
                                </div> -->
                                    <div class="input-radios-wrap">
                                        <ng-container *ngFor="let subplan of plan">
                                            <div>
                                                <input type="radio" formControlName="plan" value="{{subplan.plan.stripe_plan_id}}" name="plan" id="plan{{subplan.index}}">
                                                <label for="plan{{subplan.index}}">{{subplan.plan.period}} ({{subplan.plan.price}} USD*)</label>
                                            </div>
                                        </ng-container>
                                    </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="invalid-feedback d-block"
                        *ngIf="f['plan'].errors?.['required'] && (f['plan'].dirty || f['plan'].touched)">
                        Please select plan.
                    </div>
                    <div class="d-flex justify-content-end mt-3">
                        <button type="submit" class="btn btn-gold mt-2 ml-auto">Sign Up <i *ngIf="formSubmitting"
                                class="fa fa-spinner fa-spin"></i></button>
                    </div>
                </form>
            </div>
        </div>
    </div>


</div>
</div>
